module.exports = __webpack_public_path__ + "img/float-btn-live.31d3dba2.svg";